import React from 'react';
import {Grid, Typography} from "@mui/material";
import EventIcon from '@mui/icons-material/Event';
import {Link} from "react-router-dom";
import defaultEventImage from '../images/articlepic1.png';
import '../../../style/homepage/homepage.scss';
import {useTranslation} from "react-i18next";

const styles = {
    header: {
        fontFamily: 'Montserrat',
        fontSize: '1.1rem',
        fontWeight: '600',
        color: '#1C1B1F',
        marginBottom: '0.75rem',
        paddingBottom: '0.75rem',
        borderBottom: '2px solid #E8DEF8',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    title: {
        fontFamily: 'Montserrat',
        fontSize: '0.95rem',
        fontWeight: '600',
        lineHeight: '1.4',
        color: '#1C1B1F',
    },
    description: {
        fontFamily: 'Montserrat',
        fontSize: '0.8rem',
        fontWeight: '400',
        lineHeight: '1.5',
        color: '#79747E',
    },
    button: {
        fontFamily: 'Montserrat',
        fontSize: '0.75rem',
        fontWeight: '500',
        textAlign: 'center',
    },
    moreEvents: {
        fontFamily: 'Montserrat',
        fontSize: '0.9rem',
        fontWeight: '600',
        color: '#6750A4',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        transition: 'color 0.2s ease',
    }
}

const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

function UpcomingEvents({axiosEvents, loading, eventsLoading, eventThumbnails = {}}) {
    const {t} = useTranslation();

    const newDate = new Date().toJSON();
    //console.log('Current Date = ', newDate);

    let tempEvents = [];
    let events = [];
    // Checks if events are loading
    if (!loading && !eventsLoading && axiosEvents) {
        // Removing events that already passed
        for (let i = 0; i < axiosEvents.length; i++) {
            if (newDate < axiosEvents[i]?.eventTimestamp) {
                tempEvents.push(axiosEvents[i]);
            }
        }

        // Order events from a sooner date to the latest date
        for (let i = 0; i < tempEvents.length - 1; i++) {
            for (let j = i + 1; j < tempEvents.length; j++) {
                if (tempEvents[i]?.eventTimestamp > tempEvents[j]?.eventTimestamp) {
                    const temp = tempEvents[i];
                    tempEvents[i] = tempEvents[j];
                    tempEvents[j] = temp;
                }
            }
        }

        // Remove other events and only have the 3 events that are the closest to today's date
        events = tempEvents.slice(0, 3);
        //console.log('Upcoming Events = ', events);
    }

    /*let d1 = new Date('2023-12-01T19:11:11.000Z');
    let d2 = new Date('2024-09-06T08:01:01.000Z');
    console.log('Date 1 = ', d1);
    console.log('Date 2 = ', d2);
    if (d1 > d2) {
        console.log('Date 1 is bigger');
    } else {
        console.log('Date 2 is bigger');
    }*/

    return (
        <div>
            <Grid container direction={'column'} justifyContent={'center'} spacing={2}>
                <Grid item container direction={'row'}>
                    <Typography style={styles.header}>
                        {t('Upcoming Events')}
                    </Typography>
                    <EventIcon/>
                </Grid>

                {/* List of events */}

                {
                    loading || eventsLoading
                        ?
                        <div> Loading Events </div>

                        : events.length === 0
                        ?
                        <Grid item>
                            <Typography style={{ fontFamily: 'Montserrat', fontSize: '14px', color: '#79747E' }}>
                                {t('No upcoming events at this time')}.
                            </Typography>
                        </Grid>

                        :
                        events.map((event, index) => (
                            <Grid key={index} item container direction={'row'}>
                                <Grid item container direction={'column'} spacing={1} xs={8}>
                                    {/* Event Title */}
                                    <Grid item>
                                        <Typography style={styles.title}>
                                            {event?.title}
                                        </Typography>
                                    </Grid>
                                    {/* Event Date, Time, and Location */}
                                    <Grid item>
                                        <Typography style={styles.description}>
                                            {formatDate(event?.eventTimestamp)}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Link to={'/news-events'} style={{ textDecoration: 'none' }}>
                                            <button style={{
                                                backgroundColor: '#6750A4',
                                                color: '#FFFFFF',
                                                border: 'none',
                                                borderRadius: '20px',
                                                padding: '8px 16px',
                                                cursor: 'pointer'
                                            }}>
                                                <Typography style={styles.button}>
                                                    {'View & Register'}
                                                </Typography>
                                            </button>
                                        </Link>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <img
                                        src={eventThumbnails[event?.id] || defaultEventImage}
                                        alt={'Event Thumbnail'}
                                        className={'eventPicture'}
                                    />
                                </Grid>
                            </Grid>
                        ))
                }

                {/*<Grid item container direction={'row'}>
                    <Grid item container direction={'column'} spacing={1} xs={8}>
                         Event Title
                        <Grid item>
                            <Typography>
                                {events[0]?.title}
                            </Typography>
                        </Grid>
                         Event Date, Time, and Location
                        <Grid item>
                            <Typography>
                                {events[0]?.eventTimestamp}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <button>
                                Join
                            </button>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <img src={articlepic1} alt={'Event Thumbnail'} className={'eventPicture'}/>
                    </Grid>
                </Grid>

                <Grid item container direction={'row'}>
                    <Grid item item container direction={'column'} spacing={1} xs={8}>
                        <Grid item>
                            <Typography>
                                {events[1]?.title}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography>
                                {events[1]?.eventTimestamp}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <button>
                                Join
                            </button>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <img src={articlepic1} alt={'Event Thumbnail'} className={'eventPicture'}/>
                    </Grid>
                </Grid>*/}

                <Grid item>
                    <Link to={'/news-events'}>
                        <Typography style={styles.moreEvents}>
                            {t('More Events')}
                        </Typography>

                    </Link>
                </Grid>
            </Grid>
        </div>

    )
}

export default UpcomingEvents;
